import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../../configs/api";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import AkkhorLayout from "../../layout/AkkhorLayout";
import SearchBoxModal from "../../component/SearchBoxModal";
import ProgressPaymentManager from "./ProgressPaymentTable";
import SerchBoxMulti from "../../component/SerchBoxMulti";
import NumberInput from "../../component/NumberInput";
import AlertErrorForm from "../../component/AlertErrorForm";

export default function FormTransactions() {
    const { user } = useSelector((state) => state.auth);

    const { id } = useParams();
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [detail, setDetail] = useState(null);
    const [showModalInfo, setShowModalInfo] = useState(false);

    const defaultdetail = {
        author_id: user.data.id,
        list_customer: null,
        product_id: 0,
        price: 0,
        author_id: user.data.id,
        payment_progress: [],
        status: 1
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "transactions/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                setDetail(res.data.data);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, autoRefresh]
    );

    let validForm = {
        title: Yup.string().trim().nullable().required('Nhập tên giao dịch').max(250, "Độ dài không quá 250 ký tự"),
    }

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            delete values["id"];
            if(!values.list_customer || values.list_customer.lenght == 0){
                setSubmitting(false);
                alert("Vui lòng chọn khách hàng")
            }else if (id > 0) {
                Axios.put(URL_LIST_ALL + 'transactions/' + id, values, user.config).then(res => {
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        setAutoRefresh(!autoRefresh)
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật giao dịch thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'transactions', values, user.config).then(res => {
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới giao dịch thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const detailCus = { fullname: "", mobile: "", email: "" }
    const formCustomer = useFormik({
        initialValues: detailCus,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            fullname: Yup.string().trim().nullable().required('Nhập họ tên').max(150, "Độ dài không quá 150 ký tự"),
            mobile: Yup.string().trim().nullable().required('Nhập số điện thoại').max(150, "Độ dài không quá 150 ký tự"),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setSubmitting(true)
            Axios.post(URL_LIST_ALL + 'customers', values, user.config).then(res => {
                setSubmitting(false);
                if (res.data.status == 'success') {

                    alert("Thêm thông tin khánh hàng thành công")
                    resetForm();
                } else {
                    alert(res.data.message)
                }

            }).catch(err => { console.log(err); setSubmitting(false); });

        },
    });


    return (
        <AkkhorLayout idrole="giao-dich">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/giao-dich">Danh sách giao dịch</Link>
                    </li>
                    <li>{id ? 'Sửa giao dịch' : 'Thêm mới giao dịch'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{!id ? 'Thêm mới' : 'Sửa'} Thông tin giao dịch</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 form-group">
                                <label>Tên giao dịch</label>
                                <input placeholder="VD: Giao dịch mua căn ABC" type="text" className="form-control height32" {...formik.getFieldProps("title")} />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-9 form-group mt-2">
                                <label>Chọn khách hàng <span className="text-danger">*</span></label>
                                <SerchBoxMulti apiname={"customers"} multiple={true} placeholder="Chọn khách hàng" colvalue={'id'} colname={'fullname'} defaultValue={formik.values['list_customer']} name='list_customer'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('list_customer', e)
                                    }}></SerchBoxMulti>
                                <AlertErrorForm formik={formik} name="list_customer"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-3 form-group mt-2">
                                <label>Thêm mới khách hàng</label>
                                <button type="button" className="btn btn-sm btn-outline-success" onClick={() => setShowModalInfo(!showModalInfo)}>
                                    <i className="	fas fa-plus"></i> Thêm khách hàng
                                </button>
                            </div>
                            <div className="col-12 col-sm-6  form-group">
                                <label>Chọn bảng hàng <span className="text-danger">*</span></label>
                                <SearchBoxModal apiname={"banghang"} multiple={false} placeholder="Chọn bảng hàng" colvalue={'id'} colname={'title'} defaultValue={formik.values['product_id']} name='product_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('product_id', e)
                                    }}></SearchBoxModal>
                            </div>
                            {id > 0 &&
                                <div className="col-12 col-sm-6 form-group ">
                                    <label>Mã giao dịch</label>
                                    <input placeholder="VD: 10000000000" type="text" className="form-control height32" {...formik.getFieldProps("code")} />
                                </div>
                            }
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Tổng giá trị</label>
                                <NumberInput value={formik.values['price']}
                                    onChange={(val) => formik.setFieldValue("price", val)}
                                    placeholder="Nhập số tiền" />

                            </div>
                            <div className="col-12 form-group ">
                                <ProgressPaymentManager
                                    initialPayments={formik.values['payment_progress']}
                                    onChange={(list) => {
                                        formik.setFieldValue("payment_progress", list)
                                    }}
                                />
                            </div>
                            <div className="col-12 form-group ">
                                <label>Nội dung ghi chú</label>
                                <textarea type="text" placeholder="Nhập nội dung" className="form-control" {...formik.getFieldProps("note")} autoComplete="off"></textarea>
                            </div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{formik.isSubmitting ? <div className="loader"></div> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <Modal className="modal-sale-action" show={showModalInfo} onHide={() => setShowModalInfo(false)} animation={true} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Thêm mới khách hàng</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="new-added-form" method="post" onSubmit={formCustomer.handleSubmit}>
                        <div className="row">
                            <div className="col-12 form-group mt-2">
                                <label>Họ và tên <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" {...formCustomer.getFieldProps("fullname")} />
                                <AlertErrorForm formik={formik} name="fullname"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Số điện thoại <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" {...formCustomer.getFieldProps("mobile")} />
                                <AlertErrorForm formik={formik} name="mobile"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Email</label>
                                <input placeholder="VD: abc@domain.com" type="text" className="form-control" {...formCustomer.getFieldProps("email")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Địa chỉ</label>
                                <input placeholder="VD: Số 6 Lê Văn Thiêm,..." type="text" className="form-control" {...formCustomer.getFieldProps("address")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Số căn cước công dân</label>
                                <input placeholder="VD: 0023456777" type="text" className="form-control" {...formCustomer.getFieldProps("cccd_id")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Địa chỉ thường chú</label>
                                <input placeholder="VD: Số 6 Lê Văn Thiêm,..." type="text" className="form-control" {...formCustomer.getFieldProps("cccd_address")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Nơi cấp</label>
                                <input placeholder="VD: Cục Cảnh sát QLHC về TTXH" type="text" className="form-control" {...formCustomer.getFieldProps("cccd_noicap")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Ngày cấp</label>
                                <input placeholder="VD: 15-02-2025" type="date" className="form-control" {...formCustomer.getFieldProps("cccd_date")} />
                            </div>
                            <div className="col-12 col-sm-6 form-group ">
                                <label>Ngày sinh</label>
                                <input placeholder="VD: 15-02-2025" type="date" className="form-control" {...formCustomer.getFieldProps("birthday")} />
                            </div>
                            <hr />
                            <div className="col-12 form-group ">
                                <label>Nội dung ghi chú</label>
                                <textarea type="text" placeholder="Nhập nội dung" className="form-control" {...formCustomer.getFieldProps("note")} autoComplete="off"></textarea>
                            </div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formCustomer.isSubmitting} className="btn btn-success">{formCustomer.isSubmitting ? <div className="loader"></div> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formCustomer.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </AkkhorLayout>
    );
}
